import { Box, FormControl, Grid, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { get_modelos } from '../services/api';
import { useAuthContext } from "../hooks/Auth";

export default function GetModelos({ onModeloChange }) {
  const [data, setData] = useState([]);
  const [selectedModelo, setSelectedModelo] = useState(9);
  const [userEmail, setUserEmail] = useState('');
  const [isDisabled, setIsDisabled] = useState(false);  
  const {user} = useAuthContext();
 

  useEffect(() => {
    async function ObtenerDatosDeAPI() {
      try {
        // Realiza la solicitud GET a la URL de la API
        
        const {status, data} = await get_modelos();
        // Verifica si la solicitud fue exitosa
        if (status === 200) {
          // La respuesta de la API se encuentra en response.data
          const datos = data;
          const modelosArray = Object.entries(datos).map(([id, nombre]) => ({
            nombre,
            id,
          }));          
          //Función para obtener datos del usuario
          // const user = await getWhoami();
          setUserEmail(user.email);
          // console.log(user.email);
          
          // Asignar todos los modelos sin filtrar
          setData(modelosArray);

          // Imprime los datos en la consola en formato JSON
          // console.log(JSON.stringify(datos, null, 2));
        } else {
          console.error('La solicitud a la API no fue exitosa.');
        }
      } catch (error) {
        console.error('Se produjo un error al realizar la solicitud a la API:', error);
      }
    }

    ObtenerDatosDeAPI();
  }, []);

  useEffect(() => {
    // Valida el dominio del correo y establece la disponibilidad del Select
    setIsDisabled(!userEmail.endsWith('@tuclase.cl'));
  }, [userEmail]);

  const handleModeloChange = (event) => {
    const selectedModelo = event.target.value;
    const nameSelectedModelo = data.find((modelo) => modelo.id === selectedModelo);
    setSelectedModelo(selectedModelo);
    onModeloChange(nameSelectedModelo);
  };

  return (
    <Grid item xs={12} sx={{ marginTop: '10px' }}>
      <Typography sx={{ fontFamily: 'Inter', fontSize: '0.8rem', fontWeight: 'bold' }}>Modelos fundacionales:</Typography>
      <FormControl fullWidth>
        <Select
          labelId="select-subject"
          id="select-subject"
          label="Subject"
          variant="standard"
          value={selectedModelo}
          onChange={handleModeloChange}
          disabled={isDisabled}
          sx={{ fontFamily: 'Inter', fontSize: '14px', color: '#005559', '& fieldset': { borderColor: '#005559' }, '&:before': { borderColor: '#005559' }, '&:after': { borderColor: '#005559' } }}
        >
          {data.map((modelo) => (
            <MenuItem
              key={modelo.id}
              value={modelo.id}
              sx={{ fontFamily: 'Inter', fontSize: '12px', display: 'flex', alignItems: 'center', color: '#005559' }}
            >
              {modelo.nombre}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
  );
}
